// extracted by mini-css-extract-plugin
export default {"wrapper":"seq-label-list_wrapper__v9USl","labelItem":"seq-label-list_labelItem__lSYnu","labelItemActive":"seq-label-list_labelItemActive__vBigg"};